import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {ThemeCurrency} from '../const';
import {
    valueSync, optionValueText, optionValueClassMap, optionClassMap, 
    optionName, optionValuesGroupBy, textEditorCollapse, collapse
} from '../template/template-util.js';

// INFO: if no default value we add an empty value (required validates as false)
TemplateRegistry.templates['select'] = (option, config, onChange) => {

    // NEW: grouping support
    let groupValues = option.params.groupDelimiter ? optionValuesGroupBy(option.values, option.params.groupDelimiter) : null;

    const selectOptionTemplate = (optionValue,index) => html`
        <option class="${classMap(optionValueClassMap(option, optionValue))}" .value=${optionValue.value} ?selected=${option.value == optionValue.value} ?disabled=${optionValue.disabled}> ${optionValueText(option, optionValue, ThemeCurrency.moneyFormat, true)}</option>
    `;

    return html`
    <select class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" .value=${live(option.value)} name="${optionName(option)}" @change=${(e) => valueSync(e, option, onChange)} ?required=${option.required} form=${ifDefined(config.productFormLink)}>
        ${!option.value ? html`
           <option value="" selected>${option.params.textValueSelect || ''}</option>`
         : null}

        ${groupValues?.length ? html`
            ${repeat(groupValues, (group) => group.label, (group,index) => html`
                ${group.groupLabel ? // nested group has label set
                    html`
                    <optgroup label="${group.groupLabel}">
                        ${repeat(group.values, (optionValue) => optionValue.value, selectOptionTemplate)}
                    </optgroup>`
                    : // option value without group
                    selectOptionTemplate(group, index)
                }
            `)}`
           : // default option values without group
            html`${repeat(option.values || [], (optionValue) => optionValue.value, selectOptionTemplate)}`
        }
    </select>
    ${option._editor ? (option._layer.params.collapse ?
            html`${collapse(textEditorCollapse(option),TemplateRegistry.templates['text_editor'](option, config, onChange), false, 'cl-po--edit')}`
            : html`${TemplateRegistry.templates['text_editor'](option, config, onChange)}`): null}
`};